import { render, staticRenderFns } from "./custom-datepicker.vue?vue&type=template&id=2c879486&"
import script from "./custom-datepicker.vue?vue&type=script&lang=js&"
export * from "./custom-datepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports